export const pantryIngredients = [43, 44, 267918]; // salt, black pepper, water

export default pantryIngredients;
